<template>
  <div class="page">
    <van-skeleton title :row="6" :loading="loading">
      <div class="app-card">
        <div class="title">{{ hetong.name }}</div>
        <div class="content">
          <div class="content-item">
            <span class="label"><img src="~@/assets/ht_com.png" alt="">入职单位</span>
            <span>{{ hetong.companyName }}</span>
          </div>
          <div class="content-item">
            <div class="label"><img src="~@/assets/ht_time.png" alt=""> 入职日期</div>
            <div>{{ hetong.paiqianStartDate }}</div>
          </div>
          <div class="content-item">
            <span class="label"><img src="~@/assets/ht_type.png" alt="">合同类型</span>
            <span>{{ hetong.hetongType || '--' }}</span>
          </div>
          <div class="content-item">
            <span class="label"><img src="~@/assets/ht_time.png" alt="">合同开始日期</span>
            <span>{{ hetong.hetongStart }}</span>
          </div>
          <div class="content-item">
            <span class="label"><img src="~@/assets/ht_time.png" alt="">合同结束日期</span>
            <span>{{ hetong.hetongEnd }}</span>
          </div>
          <template v-if="hetong.shiyongMonth">
            <div class="content-item">
              <span class="label"><img src="~@/assets/ht_time.png" alt="">合同试用期</span>
              <span>{{ hetong.shiyongMonth }}个月</span>
            </div>
            <div class="content-item">
              <span class="label"><img src="~@/assets/ht_time.png" alt="">合同试用截止日期</span>
              <span>{{ hetong.shiyongEnd }}</span>
            </div>
          </template>
        </div>
      </div>
    </van-skeleton>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>

<style scoped>
.page {
  box-sizing: border-box;
}

.title {
  font-size: 20px;
  font-weight: bold;
  padding: 6px;
  text-align: center;
  border-bottom: 1px solid #eeeeee;
}

.content {
  display: flex;
  font-size: 14px;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
}

.content-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  padding: 10px 25px;
}

.label {
  display: flex;
}

.label img {
  margin-right: 10px;
}
</style>

<script>
import BindPersonnel from '@/components/BindPersonnel'
import mixinLoad from '@/mixin/mixin-load.js'

import {
  getDetail
} from '@/api/hetong.js'

export default {
  name: 'HeTong',
  components: {BindPersonnel},
  mixins: [mixinLoad],
  data() {
    return {
      hetong: {},
      loading: true
    }
  },
  methods: {
    loadData() {
      this.loading = true
      getDetail().then((rep => {
        this.hetong = rep.data;
        this.loading = false
      })).catch((rep) => {
        this.loading = false
      })

    }
  },
  created() {
    Promise.all([this.preCheck()]).then(() => {

    })
    this.loadData()
  }
}
</script>
